import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getFriends, getTopUsers, getUser, getUserId } from '../api/user';
import { useDispatch, useSelector } from 'react-redux';
import { Leaderboard, RootState } from '../redux/type';
import { setFriends, setLeaderboard, setTasks, setUserData } from '../redux/actions';
import { getTasksApi } from '../api/task';
import Loading from '../components/Loading';
import { getMaintenanceMode } from '../api/admin';

const GlobalMiddleware = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.userData);
  const leaderboard = useSelector((state: RootState) => state.leaderboard);
  const tasks = useSelector((state: RootState) => state.tasks);
  const [isLoading, setIsLoading] = useState(true);

  const updateLeaderboard = async (id: string) => {
    const newLeaderboard: Leaderboard = await getTopUsers(id);
    if (!newLeaderboard) return;
    dispatch(setLeaderboard(newLeaderboard));
  };

  const updateUserData = async (id: string) => {
    const userData = await getUser(id);
    if (!userData) return;
    dispatch(setUserData(userData));
  };

  const updateTasks = async (id: string) => {
    const newTasks = await getTasksApi(id);
    if (!newTasks) return;
    dispatch(setTasks(newTasks));
  };

  const updateFriends = async (id: string) => {
    // const newFriends = await getFriends(id);
    // if (!newFriends) return;
    // dispatch(setFriends(newFriends));
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const queryParams = new URLSearchParams(location.search);
        let uid = queryParams.get('uid');

        if (!uid) {
          uid = localStorage.getItem('global_uid');
        }

        // Telegram WebApp fallback
        if (!uid && (window as any)?.Telegram?.WebApp?.initDataUnsafe?.user?.id) {
          const telegramId = (window as any).Telegram.WebApp.initDataUnsafe.user.id;
          const resolvedUid = await getUserId(telegramId);
          if (resolvedUid) {
            uid = resolvedUid;
            localStorage.setItem('global_uid', uid);
          }
        }

        if (!uid) {
          navigate('/restricted');
          setIsLoading(false);
          return;
        }

        const user = await getUser(uid);
        if (!user || user.banned) {
          navigate('/restricted');
          setIsLoading(false);
          return;
        }

        const maintenanceMode = await getMaintenanceMode();
        if (maintenanceMode && user.role !== 'admin') {
          navigate('/maintenance');
          setIsLoading(false);
          return;
        }

        await Promise.all([
          updateLeaderboard(uid),
          updateTasks(uid),
          updateFriends(uid),
        ]);

        dispatch(setUserData(user));
      } catch (error) {
        console.error("Bootstrap error:", error);
        navigate('/restricted');
      } finally {
        setIsLoading(false);
      }
    };

    fetchUser();
  }, [location.search]);

  if (isLoading) {
    return <Loading />;
  }

  return <>{children}</>;
};

export default GlobalMiddleware;
